"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleStore = void 0;
var ethers_1 = require("ethers");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
var types_1 = require("../types");
var utils_1 = require("./utils");
var CollectibleStore = /** @class */ (function () {
    function CollectibleStore(_a) {
        var collectibleAddress = _a.collectibleAddress, sharedExtensionAddress = _a.sharedExtensionAddress, _b = _a.collectibleInstanceId, collectibleInstanceId = _b === void 0 ? null : _b, _c = _a.network, network = _c === void 0 ? frontend_provider_types_1.EthereumNetwork.MAINNET : _c, appName = _a.appName, clientId = _a.clientId, _d = _a.authMessage, authMessage = _d === void 0 ? 'Please sign this message to access the presale' : _d, _f = _a.pricingType, pricingType = _f === void 0 ? types_1.PricingType.DEFAULT : _f, _g = _a.contractType, contractType = _g === void 0 ? 'erc721' : _g, _h = _a.shouldDelayAuth, shouldDelayAuth = _h === void 0 ? false : _h;
        var _this = this;
        this.subscriptions = [];
        this.defaultState = {
            isLoading: true,
            offset: 0,
            isFetchingClaimEligibility: false,
            isFetchingPresaleEligibility: false,
            transactionLimit: '0',
            purchaseMax: '0',
            purchasePrice: '0',
            purchaseLimit: '0',
            presalePurchasePrice: '0',
            presalePurchaseLimit: '0',
            purchaseCount: 0,
            active: false,
            presaleInterval: 0,
            claimStartTime: new Date(0),
            claimEndTime: new Date(0),
            useDynamicPresalePurchaseLimit: false,
            offsetLoaded: false,
            tokensRemaining: 0,
            currentPrice: '0',
            currentPriceWithMintFee: '0',
            finalized: false,
            pricingType: types_1.PricingType.DEFAULT,
            claimEligibility: null,
            presaleEligibility: null,
            pricingData: {
                type: types_1.PricingType.DEFAULT,
            },
            refundData: {
                type: types_1.PricingType.DEFAULT,
            },
            isPurchasing: false,
            purchaseableAmount: 0,
            isSharedContract: false,
        };
        this.subscribe = function (stateNameOrFn, fn) {
            if (typeof stateNameOrFn === 'string' && typeof fn === 'function') {
                _this.subscriptions.push({ fn: fn, stateName: stateNameOrFn });
                try {
                    fn(_this.state, _this.state);
                }
                catch (_e) { }
            }
            else if (typeof stateNameOrFn === 'function') {
                _this.subscriptions.push({ fn: stateNameOrFn });
                try {
                    stateNameOrFn(_this.state, _this.state);
                }
                catch (_e) { }
            }
            else {
                throw new Error('Invalid arguments passed to `subscribe` function');
            }
            return function () { return _this.unsubscribe(stateNameOrFn, fn); };
        };
        var isSharedContract = Boolean((typeof collectibleInstanceId === 'number' || typeof collectibleInstanceId === 'string') &&
            collectibleInstanceId !== '');
        if (isSharedContract && !sharedExtensionAddress) {
            throw new Error('Shared contract must have a shared extension address');
        }
        this._state = __assign(__assign({}, this.defaultState), { collectibleAddress: collectibleAddress.toLowerCase(), sharedExtensionAddress: sharedExtensionAddress === null || sharedExtensionAddress === void 0 ? void 0 : sharedExtensionAddress.toLowerCase(), collectibleInstanceId: collectibleInstanceId, isSharedContract: isSharedContract, collectibleId: (0, utils_1.formatCollectibleId)(collectibleAddress, isSharedContract && collectibleInstanceId ? collectibleInstanceId : undefined), network: network, pricingType: pricingType, contractType: contractType, appName: appName, clientId: clientId, authMessage: authMessage, shouldDelayAuth: shouldDelayAuth });
        // Trigger an empty state update periodicially so that we can update
        // any time-based derived state (e.g. sale phase)
        setInterval(function () {
            _this.setState({});
        }, 1000);
    }
    Object.defineProperty(CollectibleStore.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (newState) {
            var _this = this;
            var prevState = this._state;
            this.updateDerivedState(newState);
            this._state = newState;
            // The publish happens async to ensure if the state gets updated again it's not in the same loop.
            Promise.resolve().then(function () { return _this._publishNewState(prevState); });
        },
        enumerable: false,
        configurable: true
    });
    CollectibleStore.prototype.unsubscribe = function (stateNameOrFn, fn) {
        var index = this.subscriptions.findIndex(function (subscription) {
            if (typeof stateNameOrFn === 'string' && typeof fn === 'function') {
                return subscription.stateName === stateNameOrFn && subscription.fn === fn;
            }
            return subscription.fn === stateNameOrFn;
        });
        if (index > -1) {
            this.subscriptions.splice(index, 1);
        }
    };
    CollectibleStore.prototype.setState = function (newState) {
        this.state = __assign(__assign({}, this._state), newState);
    };
    CollectibleStore.prototype.replaceState = function (newState) {
        this.state = newState;
    };
    CollectibleStore.prototype.updateDerivedState = function (state) {
        var _a, _b, _c;
        state.salePhase = this.deriveSalePhase(state);
        state.allSalePhases = this.deriveAllSalePhases(state);
        state.currentPrice = (_a = this.deriveCurrentPrice(state)) !== null && _a !== void 0 ? _a : '0';
        state.currentPriceWithMintFee = (_b = this.deriveCurrentPriceWithMintFee(state)) !== null && _b !== void 0 ? _b : '0';
        state.purchaseableAmount = (_c = this.derivePurchaseableAmount(state)) !== null && _c !== void 0 ? _c : 0;
        state.countdown = this.deriveCountdown(state);
        state.hasPresale = state.allSalePhases.includes(types_1.SalePhase.PRESALE);
        state.hasClaim = state.allSalePhases.includes(types_1.SalePhase.CLAIM);
        state.hasPublicSale = state.allSalePhases.includes(types_1.SalePhase.PUBLIC_SALE);
    };
    CollectibleStore.prototype._publishNewState = function (prevState) {
        var _this = this;
        if ((0, lodash_isequal_1.default)(prevState, this.state)) {
            return;
        }
        this.subscriptions.forEach(function (_a) {
            var fn = _a.fn, stateName = _a.stateName;
            if (stateName && prevState && _this.state && prevState[stateName] === _this.state[stateName]) {
                return;
            }
            try {
                fn(_this.state, prevState);
            }
            catch (e) { }
        });
        if (typeof jest === 'undefined') {
            console.groupCollapsed("%c COLLECTIBLE_STATE_UPDATE", 'font-weight: bold');
            console.table(Object.keys(this.state).reduce(function (acc, key) {
                var _a;
                if (!(0, lodash_isequal_1.default)(_this.state[key], prevState[key])) {
                    acc[key] = (_a = {},
                        _a['Previous Value'] = typeof prevState[key] === 'object'
                            ? JSON.stringify(prevState[key])
                            : prevState[key],
                        _a['Current Value'] = typeof _this.state[key] === 'object'
                            ? JSON.stringify(_this.state[key])
                            : _this.state[key],
                        _a);
                }
                return acc;
            }, {}));
            console.log(__assign({}, this.state));
            console.groupEnd();
        }
    };
    CollectibleStore.prototype.deriveSalePhase = function (state) {
        var claimStartTime = state.claimStartTime, tokensRemaining = state.tokensRemaining, active = state.active, startTime = state.startTime, endTime = state.endTime, presaleEndTime = state.presaleEndTime, claimEndTime = state.claimEndTime, offset = state.offset;
        var isLoading = !startTime || !endTime || !presaleEndTime || claimEndTime === undefined;
        if (isLoading) {
            return types_1.SalePhase.LOADING;
        }
        else if (!active) {
            return types_1.SalePhase.DEACTIVATED;
        }
        else if (tokensRemaining === 0) {
            return types_1.SalePhase.SOLD_OUT;
        }
        else {
            var isClaim = Boolean(claimStartTime && claimEndTime);
            var isInFuture = function (time) {
                return Date.now() + (offset || 0) < time.getTime();
            };
            if (isClaim && isInFuture(claimStartTime)) {
                return types_1.SalePhase.TO_CLAIM;
            }
            else if (isClaim && isInFuture(claimEndTime)) {
                return types_1.SalePhase.CLAIM;
            }
            else if (isInFuture(startTime)) {
                if (startTime.getTime() !== presaleEndTime.getTime()) {
                    return types_1.SalePhase.TO_PRESALE;
                }
                else {
                    return types_1.SalePhase.TO_PUBLIC_SALE;
                }
            }
            else if (isInFuture(presaleEndTime)) {
                return types_1.SalePhase.PRESALE;
            }
            else if (isInFuture(endTime)) {
                return types_1.SalePhase.PUBLIC_SALE;
            }
            else {
                return types_1.SalePhase.EXPIRED;
            }
        }
    };
    CollectibleStore.prototype.deriveCurrentPrice = function (state) {
        var salePhase = state.salePhase, presalePurchasePrice = state.presalePurchasePrice, purchasePrice = state.purchasePrice, pricingData = state.pricingData;
        if (salePhase === types_1.SalePhase.CLAIM) {
            return '0';
        }
        else if (salePhase === types_1.SalePhase.PRESALE) {
            return presalePurchasePrice;
        }
        else if ((pricingData === null || pricingData === void 0 ? void 0 : pricingData.type) === types_1.PricingType.DUTCH_AUCTION && pricingData.priceDropInterval) {
            var currentDiscount = this.getDutchAuctionTimeElapsed(state)
                .div(pricingData.priceDropInterval)
                .mul(pricingData.priceDropMagnitude);
            var currentPrice = ethers_1.BigNumber.from(purchasePrice !== null && purchasePrice !== void 0 ? purchasePrice : '0').sub(currentDiscount);
            return currentPrice.gt(pricingData.minimumPrice) ? currentPrice : pricingData.minimumPrice;
        }
        return purchasePrice;
    };
    CollectibleStore.prototype.deriveCurrentPriceWithMintFee = function (state) {
        return ethers_1.BigNumber.from(state.currentPrice)
            .add(state.mintFee || '0')
            .toString();
    };
    CollectibleStore.prototype.derivePurchaseableAmount = function (state) {
        var _a, _b;
        if (!state.active || ![types_1.SalePhase.PRESALE, types_1.SalePhase.PUBLIC_SALE].includes(state.salePhase)) {
            return 0;
        }
        var txLimit = ethers_1.BigNumber.from(state.transactionLimit).isZero()
            ? state.tokensRemaining
            : ethers_1.BigNumber.from(state.transactionLimit).toNumber();
        if (state.salePhase === types_1.SalePhase.PRESALE) {
            if (state.useDynamicPresalePurchaseLimit) {
                return Math.min((_b = (_a = state.presaleEligibility) === null || _a === void 0 ? void 0 : _a.remainingAmount) !== null && _b !== void 0 ? _b : 0, state.tokensRemaining);
            }
            return Math.min(!state.useDynamicPresalePurchaseLimit && ethers_1.BigNumber.from(state.presalePurchaseLimit).isZero()
                ? state.tokensRemaining
                : ethers_1.BigNumber.from(state.presalePurchaseLimit).toNumber() -
                    ethers_1.BigNumber.from(state.purchaseLimit).toNumber(), state.tokensRemaining, txLimit);
        }
        else {
            var purchaseLimit = ethers_1.BigNumber.from(state.purchaseLimit).toNumber();
            var purchaseCount = ethers_1.BigNumber.from(state.purchaseCount).toNumber();
            return Math.min(purchaseLimit === 0 ? state.tokensRemaining : Math.min(purchaseLimit, purchaseCount), state.tokensRemaining, txLimit);
        }
    };
    CollectibleStore.prototype.deriveCountdown = function (state) {
        switch (state.salePhase) {
            case types_1.SalePhase.TO_CLAIM:
                return {
                    date: state.claimStartTime,
                    label: 'Claim Starts',
                };
            case types_1.SalePhase.CLAIM:
                return {
                    date: state.claimEndTime,
                    label: 'Claim Ends',
                };
            case types_1.SalePhase.DEACTIVATED:
                return {
                    label: 'Starting soon',
                };
            case types_1.SalePhase.TO_PRESALE:
                return {
                    date: state.startTime,
                    label: 'Presale Starts',
                };
            case types_1.SalePhase.PRESALE:
                return {
                    date: state.presaleEndTime,
                    label: 'Presale Ends',
                };
            case types_1.SalePhase.TO_PUBLIC_SALE:
                return {
                    date: state.startTime,
                    label: 'Sale Starts',
                };
            case types_1.SalePhase.PUBLIC_SALE:
                return {
                    date: state.endTime,
                    label: 'Sale Ends',
                };
            case types_1.SalePhase.SOLD_OUT:
                return {
                    date: state.endTime,
                    label: 'Sold Out',
                };
            case types_1.SalePhase.EXPIRED:
                return {
                    date: state.endTime,
                    label: 'Sale Ended',
                };
            case types_1.SalePhase.LOADING:
            default:
                return;
        }
    };
    CollectibleStore.prototype.deriveAllSalePhases = function (state) {
        var _a, _b, _c, _d, _f, _g;
        var salePhases = [];
        if (state.claimStartTime &&
            ((_a = state.claimStartTime) === null || _a === void 0 ? void 0 : _a.getTime()) > 0 &&
            state.claimEndTime &&
            ((_b = state.claimEndTime) === null || _b === void 0 ? void 0 : _b.getTime()) > 0) {
            salePhases.push(types_1.SalePhase.CLAIM);
        }
        if (((_c = state.presaleEndTime) === null || _c === void 0 ? void 0 : _c.getTime()) &&
            state.presaleEndTime.getTime() !== ((_d = state.startTime) === null || _d === void 0 ? void 0 : _d.getTime())) {
            salePhases.push(types_1.SalePhase.PRESALE);
        }
        // The contract enforces that sale end time is always set, but check that it is a reasonable duration
        // after claim / presale end time in order to consider the public sale sale phase to be included.
        if (state.endTime &&
            (!state.claimEndTime || state.endTime.getTime() - ((_f = state.claimEndTime) === null || _f === void 0 ? void 0 : _f.getTime()) > 10000) &&
            (!state.presaleEndTime || state.endTime.getTime() - ((_g = state.presaleEndTime) === null || _g === void 0 ? void 0 : _g.getTime()) > 10000)) {
            salePhases.push(types_1.SalePhase.PUBLIC_SALE);
        }
        return salePhases;
    };
    CollectibleStore.prototype.getDutchAuctionTimeElapsed = function (state) {
        if (state.pricingData.type !== types_1.PricingType.DUTCH_AUCTION ||
            state.salePhase !== types_1.SalePhase.PUBLIC_SALE) {
            return ethers_1.BigNumber.from(0);
        }
        return ethers_1.BigNumber.from(Date.now() - state.presaleEndTime.getTime() + 1000).div(1000);
    };
    return CollectibleStore;
}());
exports.CollectibleStore = CollectibleStore;
